var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03BasesConcurso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-preview",
    style: {
      maxWidth: "100%",
      maxHeight: 500
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_519_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1991 118.713H37.2971C35.4583 118.713 34 117.255 34 115.416V28.2971C34 26.4583 35.4583 25 37.2971 25H103.683C105.521 25 106.98 26.4583 106.98 28.2971V73.632C106.98 74.8367 105.965 75.8512 104.761 75.8512C103.556 75.8512 102.541 74.8367 102.541 73.632V29.4384H38.4384V114.275H74.1991C75.4038 114.275 76.4183 115.289 76.4183 116.494C76.4183 117.699 75.4038 118.713 74.1991 118.713Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8005 121.313C87.7045 121.313 78.7009 112.31 78.7009 101.214C78.7009 90.1178 87.7045 81.1143 98.8005 81.1143C109.896 81.1143 118.9 90.1178 118.9 101.214C118.9 112.31 109.896 121.313 98.8005 121.313ZM98.8005 85.4892C90.1773 85.4892 83.1393 92.5273 83.1393 101.15C83.1393 109.774 90.1773 116.812 98.8005 116.812C107.424 116.812 114.462 109.774 114.462 101.15C114.462 92.5273 107.424 85.4892 98.8005 85.4892Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1628 48.1435H60.6303C59.4256 48.1435 58.4111 47.129 58.4111 45.9243C58.4111 44.7196 59.4256 43.7051 60.6303 43.7051H89.1628C90.3675 43.7051 91.382 44.7196 91.382 45.9243C91.382 47.129 90.3675 48.1435 89.1628 48.1435Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1628 59.5556H60.6303C59.4256 59.5556 58.4111 58.5411 58.4111 57.3364C58.4111 56.1317 59.4256 55.1172 60.6303 55.1172H89.1628C90.3675 55.1172 91.382 56.1317 91.382 57.3364C91.382 58.5411 90.3675 59.5556 89.1628 59.5556Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1628 70.9687H60.6303C59.4256 70.9687 58.4111 69.9542 58.4111 68.7495C58.4111 67.5448 59.4256 66.5303 60.6303 66.5303H89.1628C90.3675 66.5303 91.382 67.5448 91.382 68.7495C91.382 69.9542 90.3675 70.9687 89.1628 70.9687Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7246 48.5235C51.1604 48.5235 52.3243 47.3596 52.3243 45.9238C52.3243 44.4881 51.1604 43.3242 49.7246 43.3242C48.2889 43.3242 47.125 44.4881 47.125 45.9238C47.125 47.3596 48.2889 48.5235 49.7246 48.5235Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7246 59.9366C51.1604 59.9366 52.3243 58.7727 52.3243 57.3369C52.3243 55.9012 51.1604 54.7373 49.7246 54.7373C48.2889 54.7373 47.125 55.9012 47.125 57.3369C47.125 58.7727 48.2889 59.9366 49.7246 59.9366Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7246 71.3496C51.1604 71.3496 52.3243 70.1858 52.3243 68.75C52.3243 67.3143 51.1604 66.1504 49.7246 66.1504C48.2889 66.1504 47.125 67.3143 47.125 68.75C47.125 70.1858 48.2889 71.3496 49.7246 71.3496Z",
    fill: "#84bd00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2299 111.231L89.0995 106.032C88.0216 105.398 87.6411 104.066 88.2752 102.989C88.9093 101.911 90.2408 101.53 91.3187 102.164L96.7081 105.271L104.951 91.5755C105.585 90.4977 106.916 90.1806 107.994 90.8147C109.072 91.4487 109.389 92.7803 108.755 93.8581L98.2299 111.231Z",
    fill: "#84bd00"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 72.5,
    r: 69.5,
    stroke: "#84bd00",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_519_2541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.9,
    height: 96.313,
    fill: "#84bd00",
    transform: "translate(34 25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03BasesConcurso);
export default __webpack_public_path__ + "static/media/icon03-bases-concurso.5a5581898c3b1068a54ed2a80ce5e570.svg";
export { ForwardRef as ReactComponent };